// extracted by mini-css-extract-plugin
export default {"component":"styles_component__HH4nD","card":"styles_card__3yvig"};